import React from 'react'
import './App.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import About from './pages/About'
import Contact from './pages/Contact'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import Services from './pages/Services'
import Gallery from './pages/Gallery'
import Testimonials from './pages/Testimonials'
import VideoGallery from './pages/VideoGallery'
import BabyShowers from './pages/BabyShowers'
import Birthdays from './pages/Birthdays'
import Graduations from "./pages/Graduations"
import Weddings from "./pages/Weddings"
import Gala from "./pages/Gala"


function App() {
  return (
    <BrowserRouter>
        <ScrollToTop />
        <Navbar />
      <div class="app">
        <Routes>
        <Route path="/" element={<Gallery />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery/>} />
        <Route path="/video-gallery" element={<VideoGallery/>} />
        <Route path="/testimonials" element={<Testimonials/>} />
        <Route path="/babyshowers" element={<BabyShowers />} />
        <Route path="/birthdays" element={<Birthdays />} />
        <Route path="/graduations" element={<Graduations />} />
        <Route path="/weddings" element={<Weddings />} />
        <Route path="/gala" element={<Gala />} />
      </Routes>
      </div>
      <Footer />
    </BrowserRouter>
  )
}

export default App